const data = {
  id: 1,
  title: 'Listen and choose the correct picture',
  subTitle: 'Nghe và chọn hình chính xác.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/eb4bd056-baaa-4377-a5b7-f5034ef8f5be.mp3',
  question: '',
  answers: [
    { id: 1, answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/boat.png', isCorrect: true },
    { id: 2, answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/sun.png', isCorrect: false },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      // direction: 'vertical',
      bulletType: 'character',
      imageAnswers: true, // True là vẽ hình, False hoặc không có là vẽ Button.
      columnImageAnswers: 2, // Số cột và hình nên đi cặp cùng nhau.
    },
  },
};

export default data;
